/* eslint-disable camelcase */

/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import AskCreateTemplateIcon from '../../../assets/DisputeNotification.png';
import CreatedTemplateIcon from '../../../assets/TemplateCreatedSuccessIcon.png';
import warningImageIcon from '../../../assets/warningImage.png';
import { ControlDialogBox } from '../../../components/controlDialogBox/ControlDialogBox';
import { selectCurrentEmpid, selectCurrentUser } from '../../../pages/login/authSlice';
import {
    AssignmentTabIndex,
    CaApprovalAction,
    CaMenuTabindex,
    CaStatus,
    CaStatusNames,
    CaUserTypes,
} from '../../../utils/typeConstants';
import './CaManagerTlView.scss';
import { useDeleteCorrectiveActionMutation, useUpdateCorreciveActionMutation } from './CaMangerTLView.slice';
import { useGetCaApprovalStatusHistoryQuery } from '../../../pages/correctiveActions/correctiveActionsSlice';
import { CAMENU } from '../../../constants';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

interface updateProps {
    employeeNumber: number;
    correctiveActionId: number;
    status: string;
    setActiveIndex?: (e: number) => void;
    authorId: string;
    authorsManagerNumber?: string | undefined;
    selectedCategory: string | undefined | number;
    selectedSubCategory: string | undefined | number;
    selectedMisconduct: string | undefined | number;
    selectedSeverityLevel: string | undefined | number;
    notice: string | undefined;
    type: string;
    via?: string;
    handleClickYes: () => void;
    handleCloseDialog?: () => void;
    setIsSave: (e: boolean) => void;
    supervisorNumber?: string;
    managerNumber?: string;
}

export const CaButton = (props: updateProps) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [comments, setComments] = useState<string>();
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [warnMessage, setWarningMessage] = useState<string>('');
    const [userType, setUserType] = useState<string>();
    const [successMessage, setSuccessMessage] = useState<string>('');
    const [UpdateCorrectiveAction] = useUpdateCorreciveActionMutation();
    const [DeleteCorrectiveAction] = useDeleteCorrectiveActionMutation();
    const [updateStatus, setUpdateStatus] = useState<CaStatusNames>();
    const [successHeader, setSuccessHeader] = useState<string>('');
    const [askcreateTempDialogVisible, setAskcreateTempDialogVisible] = useState<boolean>(false);
    const [askDeleteTempDialogVisible, setAskDeleteTempDialogVisible] = useState<boolean>(false);
    const [createdSuccessTempdialogVisible, setCreatedSuccessTempdialogVisible] = useState<boolean>(false);
    const navigate = useNavigate();
    const { data: caApprovalStatusHistory } = useGetCaApprovalStatusHistoryQuery(
        {
            caId: props.correctiveActionId,
        },
        {
            skip: !props.correctiveActionId,
        }
    );
    useEffect(() => {
        window.onpopstate = () => {
            navigate(CAMENU + '/' + CaMenuTabindex.NeedsAction);
        };
    }, []);

    useEffect(() => {
        // Check approver status first (highest priority)
        const isApproverExists = caApprovalStatusHistory?.data?.some(
            (item: any) =>
                item.approver_employee_id === loggedEmpNum &&
                item.ca_approval_action_name === 'Current Approver'
        );

        if (isApproverExists) {
            setUserType(CaUserTypes.approver);
            return; // Exit early
        }

        // Check TL/Manager role
        if (loggedEmpNum === props.supervisorNumber || loggedEmpNum === props.managerNumber) {
            setUserType(CaUserTypes.TLOrManager);
            return;
        }

        // Check author role (lowest priority)
        if (loggedEmpNum === props.authorId || loggedEmpNum === props.authorsManagerNumber) {
            setUserType(CaUserTypes.author);
            return;
        }

        // If no role matches, set to undefined to hide all buttons
        setUserType(undefined);
    }, [
        caApprovalStatusHistory,
        loggedEmpNum,
        props.authorId,
        props.authorsManagerNumber,
        props.supervisorNumber,
        props.managerNumber,
    ]);
    const createdSuccessTempDialogFuncMap = {
        createdSuccessTempDialogBox: setCreatedSuccessTempdialogVisible,
    };
    const askCreateTempDialogFuncMap = {
        askCreateTempDialogBox: setAskcreateTempDialogVisible,
    };
    const askDeleteTempDialogFuncMap = {
        askDeleteTempDialogBox: setAskDeleteTempDialogVisible,
    };

    const onAskDeleteTempDialogBoxHide = () => {
        askDeleteTempDialogFuncMap.askDeleteTempDialogBox(false);
    };

    const onAskCreateTempDialogBoxHide = () => {
        askCreateTempDialogFuncMap.askCreateTempDialogBox(false);
    };

    const onCreatedSuccessTempDialogBoxHide = () => {
        createdSuccessTempDialogFuncMap.createdSuccessTempDialogBox(false);
    };

    const handleClickCancel = () => {
        props.setIsSave(false);
        onAskCreateTempDialogBoxHide();
    };

    const updateCorrectiveAction = (correctiveAction: any) => {
        UpdateCorrectiveAction(correctiveAction)
            .unwrap()
            .then((response: any) => {
                if (response.status) {
                    if (updateStatus === CaStatusNames.Recalled) {
                        setSuccessHeader('Recalled!');
                        setSuccessMessage('The corrective action has been successfully recalled');
                        setCreatedSuccessTempdialogVisible(true);
                    } else if (updateStatus === CaStatusNames.Draft) {
                        setSuccessMessage('Corrective action has been succesfully saved as draft');
                        setSuccessHeader('Saved!');
                        setCreatedSuccessTempdialogVisible(true);
                    } else if (updateStatus === CaStatusNames.Release) {
                        setSuccessHeader('Released!');
                        setSuccessMessage('The corrective action has been successfully released');
                        setCreatedSuccessTempdialogVisible(true);
                    } else if (updateStatus === CaStatusNames.Approved) {
                        setSuccessHeader('Approved!');
                        setSuccessMessage('The corrective action has been successfully approved');
                        setCreatedSuccessTempdialogVisible(true);
                    } else if (updateStatus === CaStatusNames.Rejected) {
                        setSuccessHeader('Rejected!');
                        setSuccessMessage('The corrective action has been successfully rejected');
                        setCreatedSuccessTempdialogVisible(true);
                    } else {
                        toast.success('Corrective action has been succesfully updated');
                    }
                    if (props.via === 'scorecardDashboard') {
                        props.handleCloseDialog?.();
                    } else {
                        props.setActiveIndex?.(AssignmentTabIndex.Dashboard);
                    }
                } else {
                    toast.error('Error');
                }
            })
            .then((error: any) => {
                if (error) toast.error('Error');
            });
    };

    const handleClickYes = async () => {
        let correctiveAction: any = {};

        // Validate comments for actions that require them
        if (updateStatus === CaStatusNames.Approved || updateStatus === CaStatusNames.Rejected) {
            if (!comments?.trim()) {
                toast.error('Please add comments');
                return;
            }
        }

        if (updateStatus === CaStatusNames.Recalled) {
            correctiveAction = {
                corrective_action_id: props.correctiveActionId,
                employee_number: props.employeeNumber,
                ca_approval_action_comment: comments,
                ca_status_id: CaStatus.Recalled,
                ca_approval_action_id: CaApprovalAction.Recall,
            };
        }
        if (updateStatus === CaStatusNames.Approved) {
            correctiveAction = {
                corrective_action_id: props.correctiveActionId,
                employee_number: props.employeeNumber,
                ca_approval_action_comment: comments,
                ca_status_id: CaStatus.Approved,
                ca_approval_action_id: CaApprovalAction.Approve,
            };
        }
        if (updateStatus === CaStatusNames.Rejected) {
            correctiveAction = {
                corrective_action_id: props.correctiveActionId,
                employee_number: props.employeeNumber,
                ca_approval_action_comment: comments,
                ca_status_id: CaStatus.Rejected,
                ca_approval_action_id: CaApprovalAction.Reject,
            };
        }
        if (updateStatus === CaStatusNames.Release) {
            correctiveAction = {
                corrective_action_id: props.correctiveActionId,
                employee_number: props.employeeNumber,
                ca_approval_action_comment: comments,
                ca_status_id: CaStatus.Release,
                ca_approval_action_id: CaApprovalAction.Release,
            };
        }
        if (updateStatus === CaStatusNames.Draft) {
            props.handleClickYes();
        }
        if (updateStatus === CaStatusNames.ApprovalPending) {
            //to update the modified details when submit the CA
            props.handleClickYes();
        }
        onAskCreateTempDialogBoxHide();
        if (updateStatus !== CaStatusNames.Draft && updateStatus !== CaStatusNames.ApprovalPending)
            updateCorrectiveAction(correctiveAction);
    };

    const handleUpdate = (status: string) => {
        if (status === CaStatusNames.Recalled) {
            setUpdateStatus(status);
            setWarningMessage('Are you sure you want to recall this corrective action?');
            setSuccessMessage('Recalled!');
            setSuccessHeader('Corrective action has been succesfully recalled');
        }
        if (status === CaStatusNames.Rejected) {
            setUpdateStatus(status);
            setWarningMessage('Are you sure you want to reject this corrective action?');
            setSuccessMessage('Corrective action has been succesfully rejected');
            setSuccessHeader('Recalled!');
        }
        if (status === CaStatusNames.Approved) {
            setUpdateStatus(status);
            setWarningMessage('Are you sure you want to approve this corrective action?');
            setSuccessMessage('Corrective action has been succesfully approved');
            setSuccessHeader('Approved!');
        }
        if (status === CaStatusNames.Release) {
            setUpdateStatus(status);
            setWarningMessage('Are you sure you want to release this corrective action?');
            setSuccessMessage('Corrective action has been succesfully released');
            setSuccessHeader('Released!');
        }
        if (status === CaStatusNames.Draft) {
            if (
                !props.selectedCategory ||
                !(props.selectedSubCategory || props.selectedMisconduct) ||
                !props.selectedSeverityLevel ||
                !props.notice
            ) {
                toast.error('Invalid Corrective Assignment values');
                return;
            } else {
                props.setIsSave(true);
                setUpdateStatus(status);
                setWarningMessage('Are you sure you want to save this corrective action?');
                setSuccessMessage('Corrective action has been succesfully saved');
                setSuccessHeader('Saved!');
            }
        }
        if (status === CaStatusNames.ApprovalPending) {
            if (
                !props.selectedCategory ||
                !(props.selectedSubCategory || props.selectedMisconduct) ||
                !props.selectedSeverityLevel ||
                !props.notice
            ) {
                toast.error('Invalid Corrective Assignment values');
                return;
            } else {
                setUpdateStatus(status);
                setWarningMessage('Are you sure you want to submit this corrective action?');
                setSuccessMessage('Corrective action has been succesfully submitted');
                setSuccessHeader('Submitted!');
            }
        }
        setAskcreateTempDialogVisible(true);
    };

    const handleContinue = () => {
        onCreatedSuccessTempDialogBoxHide();
        if (props.status === CaStatusNames.Draft && props.type === 'update')
            props.setActiveIndex?.(AssignmentTabIndex.Dashboard);
    };

    const createFooterTemplate = (
        <div className="d-flex justify-content-end gap-2">
            <Button
                className="btn-secondary"
                onClick={handleClickCancel}
                label="Cancel"
            />
            <Button
                className="btn-primary"
                onClick={handleClickYes}
                label="Yes"
            />
        </div>
    );

    const handleDeleteCancel = () => {
        onAskDeleteTempDialogBoxHide();
    };
    const handleDeleteYes = () => {
        DeleteCorrectiveAction(props.correctiveActionId)
            .unwrap()
            .then((response: any) => {
                if (response.data) {
                    toast.success('Corrective Action Deleted Successfully');
                    props.setActiveIndex?.(AssignmentTabIndex.Dashboard);
                } else {
                    toast.error('Error');
                }
            })
            .then((error: any) => {
                if (error) toast.error('Error');
            });
    };

    const DeleteFooterTemplate = (
        <div className="d-flex justify-content-end gap-2">
            <Button
                className="btn-secondary"
                onClick={handleDeleteCancel}
                label="Cancel"
            />
            <Button
                className="btn-primary"
                onClick={handleDeleteYes}
                label="Yes"
            />
        </div>
    );

    const CreatedSuccessfooterTemplate = (
        <div className="d-flex justify-content-end">
            <Button
                className="btn-primary"
                onClick={handleContinue}
                label="Continue"
            />
        </div>
    );

    const handleDelete = () => {
        setAskDeleteTempDialogVisible(true);
    };

    const handleCommentsChange = (value: string) => {
        setComments(value);
    };

    return (
        <>
            {props.status !== CaStatusNames.Draft &&
                props.type === 'update' &&
                userType === CaUserTypes.approver && (
                    <div className="flex justify-content-center m-top-15">
                        <DescriptionBox
                            createdByLabel="Author"
                            createdByValue={loggedEmpUserName}
                            title="Comments*"
                            responseDescription={comments}
                            value={comments}
                            limit={4000}
                            onChange={handleCommentsChange}
                        />
                    </div>
                )}

            {props.status === CaStatusNames.Draft &&
                (userType === CaUserTypes.author || userType === CaUserTypes.TLOrManager) && (
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" onClick={() => handleDelete()} className="btn-primary" label="Delete" />
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.Draft)} className="btn-primary" label="Save" />
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.ApprovalPending)} className="btn-primary" label="Submit" />
                    </div>
                )}

            {props.status === CaStatusNames.ApprovalPending &&
                (userType === CaUserTypes.author || userType === CaUserTypes.TLOrManager) && (
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.Recalled)} className="btn-primary" label="Recall" />
                    </div>
                )}

            {props.status === CaStatusNames.Approved &&
                (userType === CaUserTypes.author || userType === CaUserTypes.TLOrManager) && (
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.Recalled)} className="btn-primary" label="Recall" />
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.Release)} className="btn-primary" label="Release" />
                    </div>
                )}

            {props.status === CaStatusNames.Rejected &&
                userType === CaUserTypes.TLOrManager &&
                loggedEmpNum !== props.authorId && (
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.Recalled)} className="btn-primary" label="Recall" />
                    </div>
                )}

            {props.status === CaStatusNames.Rejected && loggedEmpNum === props.authorId && (
                <div className="d-flex justify-content-end gap-2">
                    <Button type="button" onClick={() => handleUpdate(CaStatusNames.Recalled)} className="btn-primary" label="Recall" />
                    <Button type="button" onClick={() => handleUpdate(CaStatusNames.ApprovalPending)} className="btn-primary" label="Submit" />
                </div>
            )}

            {props.status === CaStatusNames.Release &&
                (userType === CaUserTypes.author || userType === CaUserTypes.TLOrManager) && (
                    <div className="d-flex justify-content-end gap-2">
                        <Button type="button" onClick={() => handleUpdate(CaStatusNames.Recalled)} className="btn-primary" label="Recall" />
                        {props.via === 'scorecardDashboard' ? (
                            <Button type="button" onClick={() => props.handleCloseDialog?.()} className="btn-secondary" label="Close" />
                        ) : (
                            <Button type="button" onClick={() => props.setActiveIndex?.(AssignmentTabIndex.Dashboard)} className="btn-secondary" label="Return to Dashboard" />
                        )}
                    </div>
                )}

            {props.status === CaStatusNames.ApprovalPending && userType === CaUserTypes.approver && (
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        type="button"
                        onClick={() => {
                            if (comments?.trim()) {
                                handleUpdate(CaStatusNames.Approved);
                            } else {
                                toast.error('Please add comments before approving');
                            }
                        }}
                        className="btn-secondary"
                        label="Approve"
                    />
                    <Button
                        type="button"
                        onClick={() => {
                            if (comments?.trim()) {
                                handleUpdate(CaStatusNames.Rejected);
                            } else {
                                toast.error('Please add comments before rejecting');
                            }
                        }}
                        className="btn-primary"
                        label="Reject"
                    />
                </div>
            )}

            {props.status === CaStatusNames.Approved && userType === CaUserTypes.approver && (
                <div className="d-flex justify-content-end gap-2">
                    <Button type="button" onClick={() => handleUpdate(CaStatusNames.Release)} className="btn-primary" label="Release" />
                    {props.via === 'scorecardDashboard' ? (
                        <Button type="button" onClick={() => props.handleCloseDialog?.()} className="btn-secondary" label="Close" />
                    ) : (
                        <Button type="button" onClick={() => props.setActiveIndex?.(AssignmentTabIndex.Dashboard)} className="btn-secondary" label="Return to Dashboard" />
                    )}
                </div>
            )}

            <ControlDialogBox
                dialogVisibile={askcreateTempDialogVisible}
                IconPath={AskCreateTemplateIcon}
                footerTemplate={createFooterTemplate}
                subHeading={''}
                subHeadingColor={'#7D71E2'}
                msgText={warnMessage}
                onDialogBoxHide={onAskCreateTempDialogBoxHide}
            />
            <ControlDialogBox
                dialogVisibile={createdSuccessTempdialogVisible}
                footerTemplate={CreatedSuccessfooterTemplate}
                IconPath={CreatedTemplateIcon}
                subHeading={successHeader}
                subHeadingColor={'#64D96E'}
                msgText={successMessage}
                onDialogBoxHide={onCreatedSuccessTempDialogBoxHide}
            />
            <ControlDialogBox
                dialogVisibile={askDeleteTempDialogVisible}
                IconPath={warningImageIcon}
                footerTemplate={DeleteFooterTemplate}
                subHeading={''}
                subHeadingColor={'#7D71E2'}
                msgText={'Are you sure you want to Delete this corrective action?'}
                onDialogBoxHide={onAskDeleteTempDialogBoxHide}
            />
        </>
    );
};
